/**
 * The brand lockup: Megan's circular emblem paired with the SVG Wordmark.
 *
 * Her supplied logo is a near-square stacked lockup with "YOUR LANE COACHING"
 * baked into the artwork. Scaled to a 44px header it renders that type at
 * roughly 2px, so we use the half of her logo that survives at nav scale (the
 * emblem) and let the live-vector Wordmark carry the type at every size.
 *
 * Sizes are responsive so the lockup plus the mobile menu button still fit a
 * 320px viewport inside Container's horizontal padding.
 */

import { BrandMark } from './BrandMark';
import { Wordmark } from './Wordmark';

interface Props {
  variant?: 'primary' | 'inverse';
  className?: string;
}

export function BrandLockup({ variant = 'primary', className = '' }: Props) {
  const inverse = variant === 'inverse';

  return (
    <span className={`flex items-center gap-2.5 sm:gap-3.5 ${className}`}>
      <BrandMark
        variant={inverse ? 'cream' : 'ink'}
        className={inverse ? 'w-11 sm:w-14' : 'w-9 sm:w-11'}
      />
      <span
        aria-hidden
        className={`hidden h-8 w-px sm:block ${
          inverse ? 'bg-[var(--color-cream)]/20' : 'bg-[var(--color-border)]'
        }`}
      />
      <span className={`block ${inverse ? 'h-8 sm:h-10' : 'h-7 sm:h-9'}`}>
        <Wordmark variant={variant} height="100%" />
      </span>
    </span>
  );
}
